import pipe from 'lodash/fp/pipe.js';
import { connect } from 'react-redux';
import getComponent from '#components/support/polling/support/withPollingOnMount.jsx';
import { fetchUser } from '#actions/users/users.js';

const getContainer = C => {
  const mapDispatchToProps = (dispatch, ownProps) => ({
    poll: () => {
      const { userId } = ownProps.routeParams;
      const POLLING_INTERVAL = 5000;
      dispatch(fetchUser(userId));
      const pollingId = setInterval(() => {
        dispatch(fetchUser(userId));
      }, POLLING_INTERVAL);

      return () => {
        clearInterval(pollingId);
      };
    },
  });

  return connect(undefined, mapDispatchToProps)(C);
};

export default pipe(getComponent, getContainer);
